var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_1KD7{animation:spinner_6QnB 1.2s infinite}.spinner_MJg4{animation-delay:.1s}.spinner_sj9X{animation-delay:.2s}.spinner_WwCl{animation-delay:.3s}.spinner_vy2J{animation-delay:.4s}.spinner_os1F{animation-delay:.5s}.spinner_l1Tw{animation-delay:.6s}.spinner_WNEg{animation-delay:.7s}.spinner_kugV{animation-delay:.8s}.spinner_4zOl{animation-delay:.9s}.spinner_7he2{animation-delay:1s}.spinner_SeO7{animation-delay:1.1s}@keyframes spinner_6QnB{0%,50%{animation-timing-function:cubic-bezier(0.27,.42,.37,.99);r:0}25%{animation-timing-function:cubic-bezier(0.53,0,.61,.73);r:2px}}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7",
    cx: 12,
    cy: 3,
    r: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_MJg4",
    cx: 16.5,
    cy: 4.21,
    r: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_SeO7",
    cx: 7.5,
    cy: 4.21,
    r: 0
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_sj9X",
    cx: 19.79,
    cy: 7.5,
    r: 0
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_7he2",
    cx: 4.21,
    cy: 7.5,
    r: 0
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_WwCl",
    cx: 21,
    cy: 12,
    r: 0
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_4zOl",
    cx: 3,
    cy: 12,
    r: 0
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_vy2J",
    cx: 19.79,
    cy: 16.5,
    r: 0
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_kugV",
    cx: 4.21,
    cy: 16.5,
    r: 0
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_os1F",
    cx: 16.5,
    cy: 19.79,
    r: 0
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_WNEg",
    cx: 7.5,
    cy: 19.79,
    r: 0
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "spinner_1KD7 spinner_l1Tw",
    cx: 12,
    cy: 21,
    r: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.3fa5da891f0b19a270e64a65eb71af07.svg";
export { ForwardRef as ReactComponent };